import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareAccommodationModify', request)
}

export {post}
